import { GraphQLQueryClass } from "@bsm/component";
import { TUserStudentsResponse } from "@bsm/graphql";

export class StudentsQuery implements GraphQLQueryClass<TUserStudentsResponse, TResponse> {
    public queryKey: string = 'App.Bsm.UserStudents'

    public gql: string = `
        query StudentListQuery(
            $pageSize: Float,
            $page: Float,
            $data: JSONObject
            $sort: [TFilterSort!])
        {
            userStudents (filter: {
                data: $data,
                pageSize: $pageSize,
                page: $page,
                sort: $sort
            }) {
                data {
                    id
                    isEnrolled
                    user {
                        id
                        firstName
                        lastName
                        fullName
                        profilePicture {id}
                    }
                    scholarities {
                        id
                        state
                        designation
                        schoolYear
                        scholarityClass {
                            level {
                                id
                                value
                            }
                            class {
                                id
                                value
                            }
                        }
                    }
                }
            }
    }
    `

    variables?: any

    constructor(variables?: any) {
        this.variables = variables
    }

    mapFn(data: TResponse): TUserStudentsResponse {
        return data.userStudents
    }
}

type TResponse = {
    userStudents: TUserStudentsResponse
}